import { Anchor } from '@mantine/core'
import { ComponentProps, ForwardedRef, forwardRef } from 'react'
import { TrackingLabel } from '../types/tracking'
import { WithClassName } from '../types/utils'
import { Icon, IconName, IconSize } from './Icon'

type LinkProps = WithClassName &
  ComponentProps<'a'> & {
    label?: string
    icon?: IconName
    iconSize?: IconSize
    variant?: 'primary' | 'secondary'
    trackingLabel: TrackingLabel
    disabled?: boolean
    iconSpin?: boolean
  }

export const Link = forwardRef(({ className, icon, iconSpin, label, iconSize, variant = 'primary', trackingLabel, disabled, ...props }: LinkProps, ref: ForwardedRef<HTMLAnchorElement>) => (
  <Anchor ref={ref} {...props} data-tracking={trackingLabel} data-disabled={disabled || undefined} className={className} fz={variant === 'secondary' ? 'sm' : 'md'}>
    {label && <span className="overflow-hidden text-ellipsis whitespace-nowrap">{label}</span>}
    {icon && <Icon name={icon} spin={iconSpin} size={iconSize ?? (variant === 'secondary' ? 'sm' : 'md')} className={label ? 'ml-[2px]' : undefined} />}
  </Anchor>
))
